export const ADS_SIZE_CONFIG = {
  BANNER_V1: {
    ADS_SIZE_DESKTOP: [[1281, 160]],
    ADS_SIZE_MOBILE: [[382, 80]],
    CLASSNAME: 'experiment-v1',
    GET_ARRAY_INFO: 0,
  },
  BANNER_V2: {
    ADS_SIZE_DESKTOP: [[1281, 160]],
    ADS_SIZE_MOBILE: [[382, 80]],
    CLASSNAME: 'experiment-v2',
    GET_ARRAY_INFO: 1,
  },
  BANNER_V3: {
    ADS_SIZE_DESKTOP: [[1281, 160]],
    ADS_SIZE_MOBILE: [[382, 80]],
    CLASSNAME: 'experiment-v3',
    GET_ARRAY_INFO: 2,
  },
};
